// Test metadata and name helpers for AI Coach - extracted to reduce aiCoach.ts size

export const TEST_METADATA: Record<string, { name: string; category: string }> = {
  'traffic-lights-signals': { name: 'Traffic Lights & Signals', category: 'signals' },
  'priority-rules': { name: 'Priority & Right of Way', category: 'rules' },
  'hazard-perception': { name: 'Hazard Perception', category: 'safety' },
  'speed-safety': { name: 'Speed & Safety', category: 'safety' },
  'bicycle-interactions': { name: 'Bicycle Interactions', category: 'interactions' },
  'roundabout-rules': { name: 'Roundabout Rules', category: 'rules' },
  'tram-interactions': { name: 'Tram Interactions', category: 'interactions' },
  'pedestrian-crossings': { name: 'Pedestrian Crossings', category: 'interactions' },
  'construction-zones': { name: 'Construction Zones', category: 'zones' },
  'weather-conditions': { name: 'Weather Conditions', category: 'safety' },
  'road-signs': { name: 'Road Signs', category: 'signs' },
  'motorway-rules': { name: 'Motorway Rules', category: 'rules' },
  'vehicle-knowledge': { name: 'Vehicle Knowledge', category: 'vehicles' },
  'parking-rules': { name: 'Parking Rules', category: 'rules' },
  'environmental': { name: 'Environmental Zones', category: 'zones' },
  'technology-safety': { name: 'Technology & Safety', category: 'technology' },
  'alcohol-drugs': { name: 'Alcohol & Drugs', category: 'safety' },
  'fatigue-rest': { name: 'Fatigue & Rest', category: 'safety' },
  'emergency-procedures': { name: 'Emergency Procedures', category: 'safety' },
  'insight-practice': { name: 'Insight Practice', category: 'advanced' },
};

export const BEGINNER_PATH = ['traffic-lights-signals', 'priority-rules', 'hazard-perception', 'speed-safety'];

/** First 5 tests in display order; algorithm uses "next in order" until user has 5 completed, then switches to weak-area logic. */
export const FIRST_FIVE_IN_ORDER = ['traffic-lights-signals', 'road-signs', 'priority-rules', 'motorway-rules', 'hazard-perception'];

/** First 10 tests in fixed order; ensures consistent ordering for the first 10 practice tests. */
export const FIRST_TEN_IN_ORDER = [
  'traffic-lights-signals',
  'road-signs', 
  'priority-rules',
  'motorway-rules',
  'hazard-perception',
  'speed-safety',
  'bicycle-interactions',
  'road-markings',
  'risk-awareness',
  'night-visibility'
];

export function getTranslatedTestName(testId: string, translate: (key: string) => string): string {
  const testNameMap: Record<string, string> = {
    // CBR 2026 Tier 1
    'road-markings': translate('testNames.roadMarkings'),
    'motorway-rules': translate('testNames.motorwayRules'),
    'traffic-signs': translate('testNames.trafficSigns'),
    'vehicle-handling': translate('testNames.vehicleHandling'),
    'tram-interactions': translate('testNames.tramInteractions'),
    'motorway-merging': translate('testNames.motorwayMerging'),
    'risk-awareness': translate('testNames.riskAwareness'),
    'night-visibility': translate('testNames.nightVisibility'),
    // CBR 2026 Tier 2
    'weather-conditions': translate('testNames.weatherConditions'),
    'incident-first-aid': translate('testNames.incidentFirstAid'),
    'pedestrian-crossings': translate('testNames.pedestrianCrossings'),
    'vehicle-categories': translate('testNames.vehicleCategories'),
    'construction-zones': translate('testNames.constructionZones'),
    'technology-safety': translate('testNames.technologySafety'),
    'fatigue-rest': translate('testNames.fatigueRest'),
    'environmental-zones': translate('testNames.environmentalZones'),
    'vehicle-documentation': translate('testNames.vehicleDocumentation'),
    // CBR 2026 Tier 3
    'priority-rules': translate('testNames.priorityRules'),
    'mandatory-signs': translate('testNames.mandatorySigns'),
    'traffic-lights-signals': translate('testNames.trafficLightsSignals'),
    'prohibitory-signs': translate('testNames.prohibitorySigns'),
    'roundabout-rules': translate('testNames.roundaboutRules'),
    'emergency-procedures': translate('testNames.emergencyProcedures'),
    'alcohol-drugs': translate('testNames.alcoholDrugs'),
    'specialized-driving': translate('testNames.specializedDriving'),
    // Bonus
    'adas-safety': translate('testNames.adasSafety'),
    // Backward compat aliases
    'hazard-perception': translate('testNames.riskAwareness'),
    'bicycle-interactions': translate('testNames.pedestrianCrossings'),
    'road-signs': translate('testNames.trafficSigns'),
    'speed-safety': translate('testNames.motorwayRules'),
    'vehicle-knowledge': translate('testNames.vehicleCategories'),
    'parking-rules': translate('testNames.vehicleDocumentation'),
    'environmental': translate('testNames.environmentalZones'),
  };
  return testNameMap[testId] || TEST_METADATA[testId]?.name || testId.replace(/-/g, ' ');
}
